import React from "react";

interface DisplayFieldValuesProps {
  labelValues: {
    label: string;
    value: any;
  }[];
}

const DisplayFieldValues: React.FC<DisplayFieldValuesProps> = ({
  labelValues,
}) => {
  return (
    <div className="mt-5">
      <table>
        <tbody>
          {labelValues.map(({ label, value }, index) => {
            return (
              <tr key={index}>
                <td className="font-bold pr-2">{label}:</td>
                <td>{value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DisplayFieldValues;
